import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { userType } from "../../../config/userType";
import { useRegisterMutation } from "../../../features/Auth/authApi";
import AuthLayout from "../../../layouts/Auth";
import Error from "../../ErrorMessage";
import routes from "../../../config/routeConfig";

const initialValues = {
  name: "",
  email: "",
  password: "",
  "confirm-password": "",
};

export default function StudentRegister() {
  const navigate = useNavigate();
  const [formValues, setFormValues] = useState(initialValues);
  const [error, setError] = useState("");
  const [register, { isSuccess, isError, error: registerError }] =
    useRegisterMutation();

  const handleValueChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (formValues.password !== formValues["confirm-password"]) {
      alert("Password and Confirm Password must be same");
      return;
    }

    const { name, email, password } = formValues;
    const responseObj = {
      name,
      email,
      password,
      role: userType[1],
    };

    register(responseObj);
  };

  useEffect(() => {
    if (isSuccess) {
      navigate(routes.student.coursePlayer);
      setFormValues(initialValues);
    } else if (isError) {
      setError(registerError.data);
    }
  }, [isSuccess, isError]);

  return (
    <AuthLayout onSubmit={handleSubmit}>
      <div className="rounded-md shadow-sm -space-y-px">
        <div>
          {isError && <Error error={error} />}

          <label htmlFor="name" className="sr-only">
            Name
          </label>
          <input
            id="name"
            name="name"
            type="name"
            onChange={handleValueChange}
            value={formValues.name}
            autoComplete="name"
            required
            className="login-input rounded-t-md"
            placeholder="Student Name"
          />
        </div>
        <div>
          <label htmlFor="email-address" className="sr-only">
            Email address
          </label>
          <input
            id="email-address"
            name="email"
            type="email"
            onChange={handleValueChange}
            value={formValues.email}
            autoComplete="email"
            required
            className="login-input "
            placeholder="Email address"
          />
        </div>
        <div>
          <label htmlFor="password" className="sr-only">
            Password
          </label>
          <input
            id="password"
            name="password"
            type="password"
            onChange={handleValueChange}
            value={formValues.password}
            autoComplete="current-password"
            required
            className="login-input"
            placeholder="Password"
          />
        </div>
        <div>
          <label htmlFor="confirm-password" className="sr-only">
            Confirm Password
          </label>
          <input
            id="confirm-password"
            name="confirm-password"
            type="password"
            onChange={handleValueChange}
            value={formValues["confirm-password"]}
            autoComplete="confirm-password"
            required
            className="login-input rounded-b-md"
            placeholder="Confirm Password"
          />
        </div>
      </div>
    </AuthLayout>
  );
}
